// validationsForm.js


// REQUERIDO
export const validateRequired = (value,file) => {
  if (!value || value.trim() === "") {
    return "Este campo es obligatorio.";
  }
  return null;
};

export const validateNotNull = (value) => {
  if (!value) {
    return "Este campo es obligatorio.";
  }
  return null;
};

// IMAGENES
// VALIDO QUE SUB IMAGEN
export const validateImageRequired = (file) => {
  if (!file) {
    return "La imagen es obligatoria.";
  }

  // Verificar si es un archivo de tipo imagen
  if (file && file.type && !file.type.startsWith("image/")) {
    return "El archivo debe ser una imagen válida.";
  }

  return null; // Si no hay errores
};

// STRING 
// VALIDO TAMAÑO DE STRING
export const validateLength = (value, { minLength, maxLength } = {}) => {
  // Si el campo está vacío, no realizar validación
  if (!value) {
    return null;
  }

  // Validar la longitud mínima
  if (value.length < minLength) {
    return `El valor debe tener al menos ${minLength} caracteres.`;
  }

  // Validar la longitud máxima
  if (value.length > maxLength) {
    return `El valor no puede tener más de ${maxLength} caracteres.`;
  }

  // Si pasa todas las validaciones
  return null;
};

// FECHAS
// VALIDA FECHA INICIAL Y FECHA FINAL ES DECIR RANGO DE FECHAS
export const validateDateRange = (value, form, startDateFieldName, endDateFieldName) => {
  const startDate = form[startDateFieldName];
  if (startDate && new Date(value) < new Date(startDate)) {
    return `La fecha de Inicio no puede ser anterior a la fecha de Fin.`;
  }
  return null;
};
// VALIDA QUE LA FECHA INICIAL O SEA ANTES DE LA FEHCA DE HOY
export const validateStartDate = (value) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Ajustar la hora a las 00:00:00 para comparar solo las fechas

  if (new Date(value) < today) {
    return `La fecha de inicio debe ser posterior a la fecha actual`;
  }
  return null;
};

// VALIDA QUE LA FECHA INICIAL SEA HOY O UNA FECHA FUTURA
export const validateStartDateToday = (value) => { 
  const today = new Date();
  today.setHours(0, 0, 0, 0); // hoy a las 00:00

  const inputDate = new Date(value); // mantiene fecha + hora del input

  if (inputDate < today) {
    return "La fecha de inicio debe ser mayor o igual a hoy a las 00:00";
  }

  return null;
};





// NUMEROS ENTEROS
// VALIDO  SI ES ENTERO Y LA CANTIDAD MINIMO Y MAXIMA DE DIGITOS
export const validateIntLength = (value, { minLength = 1, maxLength = 11 } = {}) => {
  // Si el campo está vacío, no realizar validación
  if (!value) {
    return null;
  }

  // Verificar que el valor es un número entero positivo
  if (!/^\d+$/.test(value)) {
    return 'El valor debe ser un número entero positivo.';
  }

  // Validar la longitud mínima
  if (value.length < minLength) {
    return `El valor debe tener al menos ${minLength} dígitos.`;
  }

  // Validar la longitud máxima
  if (value.length > maxLength) {
    return `El valor no puede tener más de ${maxLength} dígitos.`;
  }

  // Si pasa todas las validaciones
  return null;
};

// VALIDA Q SEA MAYOR QUE CERO Y QUE SEA ENTERO
export const validateNonZeroInteger = (value) => {
  // Verificar si el valor está vacío o no es un número
  if (value === '' || isNaN(value)) {
    return "El campo es obligatorio";
  }

  // Convertir el valor a número
  const numericValue = Number(value);

  // Verificar si es un número entero
  if (!Number.isInteger(numericValue)) {
    return "El valor debe ser un número entero.";
  }

  // Verificar si el número es 0
  if (numericValue === 0) {
    return "El valor no puede ser 0.";
  }

  // Si pasa todas las validaciones
  return null;
};
// VALIDA QUE NO SEA CERO Y QUE NO SEA VACIO
export const validateInteger = (value) => {
  // Si el campo está vacío, no hacer ninguna validación
  if (value === '') {
    return null; // Si no hay valor, no se realiza validación
  }

  // Convertir el valor a número
  const numericValue = parseFloat(value);

  // Verificar si es un número entero
  if (!Number.isInteger(numericValue)) {
    return "No se permite campo vacio";
  }


  // Si pasa todas las validaciones
  return null;
};
// VALIDA QUE EL SELECT SEA ENTERO
export const validateSelectInteger = (value) => {
  // Verifica si el valor es un número entero no negativo
  const regex = /^[0-9]+$/;  // Expresión regular que solo permite números enteros positivos y 0
  if (value && !regex.test(value)) {
    return 'Campo Requeridos';
  }
  return null; // Si no hay error, retorna null
};

// NUMEROS FLOAT
export const validateDecimalWithLength = (value, { minLength = 1, maxLength = 10 } = {}) => {
  if (!value && value !== 0) { // Permite valores numéricos como 0
    return "Este campo es obligatorio.";
  }

  const stringValue = value.toString(); // Asegúrate de que el valor sea una cadena
  const regex = /^[0-9]{1,10}(\.[0-9]{1,2})?$/; // Hasta 10 dígitos enteros y 2 decimales opcionales

  if (!regex.test(stringValue)) {
    return "Debe ser un número positivo con máximo 2 decimales.";
  }

  // Eliminar el punto y verificar la longitud
  const numericLength = stringValue.replace('.', '').length;

  if (numericLength < minLength) {
    return `El valor debe tener al menos ${minLength} dígitos.`;
  }

  if (numericLength > maxLength) {
    return `El valor no puede tener más de ${maxLength} dígitos.`;
  }

  return null; // Válido
};


// VALIDA CORREO
export const validateEmail = (value) => {
  // Solo hacer la validación si el valor no está vacío
  if (value) {
    // Expresión regular para validar correo electrónico
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(value)) {
      return "Por favor, ingrese un correo electrónico válido.";
    }
  }
  return null;
};
// VALIDA DIRECCION WEB
export const validateURL = (value) => {
  // Solo hacer la validación si el valor no está vacío
  if (value) {
    // Expresión regular para validar URL
    const urlRegex = /^(https?:\/\/)?([\w\d-]+\.)+(com|net|org|edu|gov|ar|es|mx|cl|br|info|biz)(\/[\w\d\.-]*)*\/?$/i;
    if (!urlRegex.test(value)) {
      return "Por favor, ingrese una URL válida.";
    }
  }
  return null;
};

export const validatePhone = (value) => {
  if (value) {
    const regex = /^(?:\+54)?\s?(?:\d{2,4})\s?\d{6,8}$/;
    if (!regex.test(value)) {
      return "Número de teléfono inválido. Ej: +54 385 4894984 o 385 4894984";
    }
  }
  return null;
};